import axios from "axios";

import { I18n } from "react-redux-i18n";
import {
  AD_SELLER_REPUTATION_ATTEMPT,
  AD_SELLER_REPUTATION_SUCCESS,
  AD_SELLER_REPUTATION_FAILED
} from "../types/adSellerReputationTypes";
import { config } from "../../config";
import { authHeaders, hasAuthToken } from "../../utils/authHeaders";
const url_api = config.api.godiway;

export function loading() {
  return {
    type: AD_SELLER_REPUTATION_ATTEMPT
  };
}

export function success(item) {
  return {
    type: AD_SELLER_REPUTATION_SUCCESS,
    item: item
  };
}

export function failed(error) {
  return {
    type: AD_SELLER_REPUTATION_FAILED,
    error: error
  };
}

/**
 *   export function successScroll(data){
    return{
    type:NOTIFICATION_LIST_SCROLL,
    data:data
    }
};
*/

export const loadItem = (data: Object) => async dispatch => {
  const isAuth = hasAuthToken(data.token) && data.user_id;
  dispatch(loading());
  await axios
    .get(url_api + (isAuth ? "seller/reputation" : "seller/reputation/out"), {
      params: {
        goder_id: data.goder_id,
        ...(isAuth ? { id: data.user_id } : {}),
        lang: I18n.t("locale")
      },
      headers: authHeaders(data.token),
    })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};
